<template>
  <div class="footer-wrapper">
    <!-- Acciones Flotantes -->
    <div class="floating-actions">
      <transition name="fade-up">
        <div v-if="showWhatsAppMenu" class="whatsapp-options-container">
          <button v-if="ConfigEmpresa.chatbox_asesores" class="whatsapp-option"
            @click="openWhatsApp(ConfigEmpresa.chatbox_asesores)">
            <i class="bx bxl-whatsapp"></i> Asesores
          </button>
          <button v-if="ConfigEmpresa.chatbox_atencion" class="whatsapp-option"
            @click="openWhatsApp(ConfigEmpresa.chatbox_atencion)">
            <i class="bx bxl-whatsapp"></i> Atención
          </button>
          <button v-if="ConfigEmpresa.chatbox_tmk" class="whatsapp-option"
            @click="openWhatsApp(ConfigEmpresa.chatbox_tmk)">
            <i class="bx bxl-whatsapp"></i> TMK
          </button>
        </div>
      </transition>

      <button v-if="hasWhatsAppNumbers" class="whatsapp-btn" @click="toggleWhatsAppMenu">
        <i class="bx bx-support"></i>
      </button>

      <button class="scroll-top-btn" @click="scrollTop" :class="{ 'visible': showScrollTopBtn }">
        <i class="bx bx-up-arrow-alt"></i>
      </button>
    </div>

    <!-- Footer Compacto -->
    <footer class="footer-corporate">
      <div class="container">
        <div class="row align-items-center">
          <!-- Branding e Info -->
          <div class="col-md-7 text-center text-md-start">
            <h6 class="footer-brand">{{ ConfigEmpresa.Nombre }}</h6>
            <p class="footer-mini-info">
              <span v-if="sucursalesDataPrincipal.calle">
                <i class="bx bx-map-pin text-warning-custom"></i>
                {{ sucursalesDataPrincipal.calle }}, CP. {{ sucursalesDataPrincipal.cp }}
              </span>
              <span v-if="sucursalesDataPrincipal.telefonoprin" class="ms-md-3">
                <i class="bx bx-phone text-warning-custom"></i> {{ sucursalesDataPrincipal.telefonoprin }}
              </span>
            </p>
          </div>

          <!-- Redes Sociales -->
          <div class="col-md-5 text-center text-md-end">
            <div class="social-links">
              <a v-for="red in sucursalesDataPrincipal.redes" :key="red.id" :href="getRedSocialLink(red)"
                target="_blank" class="social-icon">
                <i :class="red.red_social.icono"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <p class="copyright">
            &copy; {{ ConfigEmpresa.ano }} <strong>{{ ConfigEmpresa.Nombre }}</strong>.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showScrollTopBtn: false, // Inicialmente oculto
      sucursalesDataPrincipal: [],
      ConfigEmpresa: [],
      whatsAppNumbers: ["5211234567890", "5210987654321"], // Ejemplo: números dinámicos
      showWhatsAppMenu: false,
    };
  },
  methods: {
    // Método para hacer scroll hacia arriba
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Desplazamiento suave
      });
    },
    // Método para mostrar u ocultar el botón flotante
    handleScroll() {
      if (window.scrollY > 100) {
        this.showScrollTopBtn = true;
      } else {
        this.showScrollTopBtn = false;
      }
    },
    sucursalescontacto() {
      axios.get(`/api/admin/contactosucursales`)
        .then(response => {
          this.sucursalesDataPrincipal = response.data.principal
          this.ConfigEmpresa = response.data.ConfigEmpresa
        })
        .catch(error => {
          console.error("Error al actualizar la sucursal:", error);
        });
    },
    getRedSocialLink(red) {
      if (!red.red_social) return '#'; // Si no hay relación, devuelve un enlace vacío.

      const baseUrl = red.red_social.link || ''; // URL base de la red social.
      const admiteMensaje = red.red_social.admite_mensaje || 0; // Por defecto, no admite mensajes.
      const mensaje = red.red_social.mensaje || 'Hola, me gustaría obtener más información'; // Mensaje predeterminado si no existe.

      // Si admite mensajes, personaliza el enlace con el mensaje.
      if (admiteMensaje) {
        return `${baseUrl}${red.valor || ''}?text=${encodeURIComponent(mensaje)}`;
      }

      // Si no admite mensajes, simplemente concatena el valor.
      return `${baseUrl}${red.valor || ''}`;
    },
    toggleWhatsAppMenu() {
      const chatboxData = [
        this.ConfigEmpresa.chatbox_asesores,
        this.ConfigEmpresa.chatbox_atencion,
        this.ConfigEmpresa.chatbox_tmk,
      ];
      // Filtrar los datos válidos (cadenas no vacías y no null)
      const filledFields = chatboxData.filter(value => typeof value === "string" && value.trim() !== "");
      if (filledFields.length === 1) {
        const singleNumber = filledFields[0];
        this.openWhatsApp(singleNumber)
      } else if (filledFields.length > 1) {
        this.showWhatsAppMenu = !this.showWhatsAppMenu;
      }

    },
    openWhatsApp(phoneNumber) {
      const message = "¡Hola! Quisiera más información."; // Mensaje predefinido.
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
      this.showWhatsAppMenu = false; // Cierra el menú al seleccionar
    },
    formatPhoneNumber(phoneNumber) {
      // Opcional: Formatea el número para mostrarlo de manera más legible
      return phoneNumber.replace(/^52/, "+52 ");
    },
  },
  mounted() {
    this.sucursalescontacto()
    // Mostrar u ocultar el botón flotante al hacer scroll
    window.addEventListener('scroll', this.handleScroll);

  },
  computed: {
    hasWhatsAppNumbers() {
      // Verificar si al menos uno de los campos no es nulo ni está vacío
      return [
        this.ConfigEmpresa.chatbox_asesores,
        this.ConfigEmpresa.chatbox_atencion,
        this.ConfigEmpresa.chatbox_tmk,
      ].some(value => typeof value === "string" && value.trim() !== "");
    }
  },
  beforeDestroy() {
    // Eliminar el event listener cuando el componente es destruido
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
.footer-wrapper {
  margin-top: 1rem;
}

.footer-corporate {
  background-color: #043c53;
  color: #ffffff;
  padding: 15px 0 10px;
  /* Reducido al mínimo */
  border-top: 3px solid #ff9900;
}

.footer-brand {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.1rem;
  /* Más pequeño */
  margin-bottom: 2px;
  text-transform: uppercase;
}

.footer-mini-info {
  color: #a5c0cb;
  font-size: 0.8rem;
  /* Texto pequeño */
  margin-bottom: 0;
}

.text-warning-custom {
  color: #ff9900 !important;
}

/* Redes Sociales Compactas */
.social-icon {
  font-size: 16px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
  text-align: center;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  margin-left: 8px;
  transition: 0.2s;
}

.social-icon:hover {
  background: #ff9900;
  color: #043c53;
}

.footer-bottom {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  text-align: center;
}

.copyright {
  font-size: 0.75rem;
  color: #a5c0cb;
  opacity: 0.6;
  margin: 0;
}

/* BOTONES FLOTANTES MÁS PEQUEÑOS */
.floating-actions {
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.whatsapp-btn {
  background-color: #25D366;
  color: white;
  border: none;
  border-radius: 50%;
  width: 45px;
  /* Bajó de 55px */
  height: 45px;
  font-size: 22px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.scroll-top-btn {
  background-color: #ff9900;
  color: #043c53;
  border: none;
  border-radius: 50%;
  width: 35px;
  /* Bajó de 45px */
  height: 35px;
  font-size: 18px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}

.scroll-top-btn.visible {
  opacity: 1;
  visibility: visible;
}

.whatsapp-options-container {
  background: white;
  padding: 6px;
  border-radius: 8px;
  margin-bottom: 5px;
}

.whatsapp-option {
  padding: 5px 12px;
  font-size: 0.75rem;
  margin-bottom: 2px;
}

@media (max-width: 767px) {
  .footer-mini-info span {
    display: block;
    margin-bottom: 3px;
  }
}
</style>